var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar"}},_vm._l((_vm.links),function(link){return _c('div',{key:link.text,staticClass:"text-button"},[_c('a',{attrs:{"href":link.href}},[_vm._v(_vm._s(link.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }